export function resaReducer(state = { 
},{
    type,
    payload
}){
    
    switch(type){
        case "NEW_RESERVATION": 
        case "UPDATE_RESERVATION": 
            return {
                [payload.id]: payload,
                ...state
            };
        case "RECEIVED_RESERVATION":        
            return {
                ...state,
                [payload]: {
                    ...state[payload],
                    received: true
                }
            }
        case "GET_RESERVATIONS":        
            return payload;
        
        case "DELETE_RESERVATION":
            const { [payload]: deleted, ...newState } = state;
            return newState;
        default:
            return state;
    }
    
}